const UPLOAD_TIPO = {
  BOT: {
    id: "BOT",
    label: "Bot",
    descricao: "Upload realizado via bot",
  },
  MAN: {
    id: "MAN",
    label: "Manual",
    descricao: "Upload realizado manualmente",
  },
  EXT: {
    id: "EXT",
    label: "Externo",
    descricao: "Upload realizado por uma fonte externa",
  },
  FND: {
    id: "FND",
    label: "FND",
    descricao: "Upload realizado via FND",
  },
};

export default UPLOAD_TIPO;
